import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromHouseConsignmentResponseV3 } from '../models/mapper'
import { HouseConsignment } from '../models/types'
import { fetchHouseConsignmentsV3 } from './http'

export async function fetchHouseConsignments(
  params: { consignmentId: number },
  opts?: { signal?: AbortSignal },
): Promise<HouseConsignment[]> {
  const responses = await fetchHouseConsignmentsV3(params, opts)
  return responses.map((response, index) => fromHouseConsignmentResponseV3(response, index))
}

export function useFetchHouseConsignments(consignmentId: number | null, enabled = true) {
  return useQuery({
    queryKey: QueryKeys.houseConsignment.all(consignmentId),
    queryFn: ({ signal }) => fetchHouseConsignments({ consignmentId: consignmentId as number }, { signal }),
    enabled: !!consignmentId && enabled,
  })
}
